import Modal from "view-design";
let modalInstance;

function getModalInstance(classname, render = undefined) {
  modalInstance =
    modalInstance ||
    Modal.Modal.newInstance({
      closable: false,
      maskClosable: false,
      footerHide: true,
      render: render,
      className: classname
    });
  return modalInstance;
}

function confirm(options, classname) {
  let instance = getModalInstance(classname);
  options.onRemove = function() {
    modalInstance = null;
  };
  instance.show(options);
}
const myConfirm = function(props = {}, classname) {
  props.icon = "confirm";
  props.showCancel = true;
  if (props.okBtn) props.okText = props.okBtn;
  if (props.cancelBtn) props.cancelText = props.cancelBtn;

  return confirm(props, classname);
};

export default myConfirm;



//////////////////
// WEBPACK FOOTER
// ./static/js/confirm.js
// module id = 62zs
// module chunks = 16